import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getWallet } from '../../../../store/selectors';
import { closeDialog } from '../../../../store/actionCreators/dialog';
import { getTournamentBuyinInfo } from '../../../Club/Main/components/Tabs/components/TournamentCasino/helpers/getTournamentBuyinInfo';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import Chips from '../../../Club/ChipBalance/Chips';


const LowBalance = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const BTN_NAMES = {
    cancel: t('close')
  }

  const close = useCallback(() => {
    dispatch(closeDialog());
  }, []);

  const info = getTournamentBuyinInfo(data);
  const walletMain = useSelector(getWallet);
  const { chipValue } = info;

  return (
    <div className="tournamentLowBalance">
      <div className="tournaments__popup__overlay" />
      <PopUpDialogTemplate
        onClose={close}
        btnNames={BTN_NAMES}
        btnClasses={{ confirm: 'primary', cancel: 'secondary' }}
      >
        <div className="insufficientBalanceText">{t('insufficientBalance')}</div>
        <div className="chip-value__wrapper">
          <span className="chip-value">{t('tournaments.price')}</span>
          {chipValue({ margin: 4 })}
        </div>
        <div className="chip-value__wrapper">
          <span className="chip-value">{t('tournaments.mainBalance')}</span>
          <Chips margin={4} val={walletMain.balance} />
        </div>
      </PopUpDialogTemplate>
    </div>
  )
}

export default LowBalance;
